/* lua.js generated code 0.3.0 */

require("clover/data/DataRef")
var uuid = require("hecore/uuid")
HttpCache = xClass("HttpCache")
HttpCache.prototype.ctor = function () {
    var self = this
    self.cacheList = table()
    self.syncSerial = null
}
HttpCache.prototype.setSyncSerial = function (seq) {
    var self = this
    self.syncSerial = seq
}
// TODO: 登录的地方在用 期望改为这个结构体中单独返回缓存列表 而不是外部去做
HttpCache.prototype.getSyncSerial = function () {
    var self = this
    return self.syncSerial
}
HttpCache.prototype.cacheHttp = function (endpoint, body) {
    var self = this
    table.insert(self.cacheList, table(
        [1, "id", uuid.getUUID()],
        [1, "endpoint", endpoint],
        [1, "body", body]
    ))
}
HttpCache.prototype.getCachedHttp = function () {
    var self = this
    for (var i = 1, v = self.cacheList[1]; v; i++, v = self.cacheList[i]) {
        if (type(v.body) === "table") {
            var ss = v.body.seq
            if (type(ss) === "number") {
                if (type(self.syncSerial) !== "number") {
                    self.syncSerial = ss
                } else if (v.body.seq > self.syncSerial) {
                    self.syncSerial = v.body.seq
                }
            } else if (type(self.syncSerial) === "number") {
                self.syncSerial = self.syncSerial + 1
                v.body.seq = self.syncSerial
            }
        }
    }
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
    // WARN: maybe multi result
    return clone(self.cacheList)
}
HttpCache.prototype.clearCachedHttp = function () {
    var self = this
    self.cacheList = table()
}
HttpCache.prototype.removeUsedHttpCache = function (list) {
    var self = this
    for (var i = 1, v = list[1]; v; i++, v = list[i]) {
        self.cacheList = table.filter(self.cacheList, function (value) {
            return value.id !== v.id
        })
    }
}
HttpCache.prototype.encode = function () {
    var self = this
    var data = table()
    for (var i = 1, v = self.cacheList[1]; v; i++, v = self.cacheList[i]) {
        table.insert(data, clone(v))
    }
    return data
}
HttpCache.prototype.fromLua = function (data) {
    var self = this
    if (type(data) !== "table") {
        return 
    }
    self.cacheList = table()
    for (var i = 1, v = data[1]; v; i++, v = data[i]) {
        table.insert(self.cacheList, table(
            [1, "id", v.id],
            [1, "endpoint", v.endpoint],
            [1, "body", v.body]
        ))
    }
}
